import toCamelCase from './toCamelCase';

export default function convertArrayToCamelCase(array) {
  if (!Array.isArray(array)) {
    return array;
  }

  return array.map((item) => {
    if (!item || typeof item !== 'object') {
      return item;
    }

    return Object.keys(item).reduce((acc, key) => {
      const camelKey = toCamelCase(key);

      return {
        ...acc,
        [camelKey]: item[key],
      };
    }, {});
  });
}
